import "core-js/stable";
import "regenerator-runtime/runtime";

import initialize from './init';
import pageTransitions from './pagetransitions';

document.addEventListener('DOMContentLoaded', () => pageTransitions());
document.addEventListener('DOMContentLoaded', () => {
	initialize(document);
});